import { IWebsiteBuilderMediaItem } from "redux/reducers/models/websiteBuilder";
import { IWebsiteBuilderImage, websiteBuilderGenerateDefaultImage } from "../../element/websiteBuilderImage";
import { TWebsiteBuilderSection } from "../websiteBuilderSection";

interface IWebsiteBuilderResolvedTemplateMedia {
  mediaId: number;
  src: string;
}

type TWebsiteBuilderResolveTemplateMediaCode =
  | "allan-nygren"
  | "aerial-golf-course"
  | "edwin-compton"
  | "gold-wedding-band"
  | "golf-course-island"
  | "golf-course-with-green-trees"
  | "man-playing-golf-during-daytime"
  | "room-with-tables-and-chairs"
  | "welcome";

function websiteBuilderResolveTemplateMedia(
  media: IWebsiteBuilderMediaItem[],
  code: TWebsiteBuilderResolveTemplateMediaCode,
): IWebsiteBuilderResolvedTemplateMedia {
  const mediaItem = media.find(mediaItem => mediaItem.code === code);

  if (mediaItem == null) {
    return {
      mediaId: null,
      src: null,
    };
  } else {
    return {
      mediaId: mediaItem.id,
      src: mediaItem.source,
    };
  }
}

export function websiteBuilderGenerateTemplateImage(
  media: IWebsiteBuilderMediaItem[],
  code: TWebsiteBuilderResolveTemplateMediaCode,
): IWebsiteBuilderImage {
  const { mediaId, src } = websiteBuilderResolveTemplateMedia(media, code);

  return websiteBuilderGenerateDefaultImage(mediaId, src);
}

export function websiteBuilderSetTemplateSectionBackgroundImage(
  sectionNode: TWebsiteBuilderSection,
  media: IWebsiteBuilderMediaItem[],
  code: TWebsiteBuilderResolveTemplateMediaCode,
): void {
  const { mediaId, src } = websiteBuilderResolveTemplateMedia(media, code);

  sectionNode.section.background.mediaId = mediaId;
  sectionNode.section.background.src = src;
}
